import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake, faFileSignature, faDollarSign, faArrowRight, faKey, faShieldAlt, faLock, faCoins, faFileContract, faHome } from '@fortawesome/free-solid-svg-icons';

const OwnerFinancing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="owner-financing-page">
      <Helmet>
        <title>Off Grid Developments LLC - Owner Financing</title>
        <meta name="description" content="Simple and stress-free owner financing options for all our properties" />
      </Helmet>

      {/* Hero Section */}
      <div className="financing-hero">
        <div className="financing-hero-overlay">
          <h1>Owner Financing</h1>
          <p>Simple and stress-free financing options that make owning land accessible to everyone</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="financing-content">
        <div className="financing-intro">
          <FontAwesomeIcon icon={faHandshake} className="financing-handshake-icon" />
          <h2>Getting Started With Our Owner Financing</h2>
          <p>
            We provide owner-financing options on all our properties, making it simple and stress-free to buy land without involving banks or traditional lenders. Below is a clear breakdown of how everything works from start to finish.
          </p>
        </div>

        <div className="financing-steps">
          <div className="financing-steps-header">
            {/* <FontAwesomeIcon icon={faDollarSign} className="financing-dollar-icon" /> */}
            <h2>Two Simple Steps to Owning Property Through Our Owner Financing</h2>
          </div>

          <div className="steps-flow">
            <div className="step-card">
              <div className="step-card-header">
                <div className="step-badge">Step 1</div>
                <FontAwesomeIcon icon={faFileSignature} className="step-card-icon" />
              </div>
              <h3>Secure Your Property</h3>
              <p>
                Your ownership journey begins after you've reviewed the property and submitted your required down payment. Then, email a copy of your driver's license and mailing address to <strong>admin@mylandgo.com</strong>. A <strong>$350 processing fee</strong> will be charged, which covers preparation of your installment note and all required legal paperwork.
              </p>
            </div>

            <div className="step-connector">
              <FontAwesomeIcon icon={faArrowRight} className="connector-icon" />
            </div>

            <div className="step-card">
              <div className="step-card-header">
                <div className="step-badge">Step 2</div>
                <FontAwesomeIcon icon={faKey} className="step-card-icon" />
              </div>
              <h3>Review & Sign Your Loan Documents</h3>
              <p>
                After we receive your payment and information, we'll send your loan documents for review, signature, and notarization. Return the completed documents, and your purchase is finalized. The property is now officially yours.
              </p>
            </div>
          </div>
        </div>

        <div className="financing-benefits">
          <div className="benefits-header">
            <h2>Why Choose Our Owner Financing?</h2>
            <p>Simple, transparent, and designed with you in mind</p>
          </div>
          <div className="benefits-list">
            <div className="benefit-item">
              <div className="benefit-icon-wrapper">
                <FontAwesomeIcon icon={faShieldAlt} className="benefit-icon" />
              </div>
              <div className="benefit-content">
                <h4>No Credit Checks</h4>
                <p>We do not run credit checks, making the process accessible to everyone.</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon-wrapper">
                <FontAwesomeIcon icon={faLock} className="benefit-icon" />
              </div>
              <div className="benefit-content">
                <h4>No Credit Reporting</h4>
                <p>We do not report to any credit bureaus, keeping your financial privacy intact.</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon-wrapper">
                <FontAwesomeIcon icon={faCoins} className="benefit-icon" />
              </div>
              <div className="benefit-content">
                <h4>Early Payoff Welcome</h4>
                <p>There are no penalties for early payoff. Pay off your loan whenever you're ready.</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon-wrapper">
                <FontAwesomeIcon icon={faFileContract} className="benefit-icon" />
              </div>
              <div className="benefit-content">
                <h4>Deed Transfer</h4>
                <p>When your loan is fully paid, we will transfer the deed to your name.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="financing-footer">
          <FontAwesomeIcon icon={faHome} className="financing-footer-icon" />
          <div className="financing-footer-text">
            <p><strong>Congratulations on your Land Investment!</strong></p>
            <p>You have officially secured your land ownership with our straightforward owner financing process</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnerFinancing;

